import { defineComponent as _defineComponent } from 'vue'
import { VCheckbox } from 'vuetify/lib/components'


export default /*#__PURE__*/_defineComponent({
  __name: 'BKCheckbox',
  props: {
    label: { default: '' },
    value: { default: false }
  },
  emits: ["change"],
  setup(__props: any) {





return { __sfc: true,VCheckbox }
}

})